import React from 'react';

import * as S from './styles';

export const Slide11: React.FC = () => {
  return (
    <S.Container>
      <S.PhotoWrapper>
        <S.Photo />
      </S.PhotoWrapper>
      <S.Content>
        <S.Legend>Beleza: Helder Rodrigues. Styling: Lucas Boccalão.</S.Legend>
        <S.Title>Créditos</S.Title>
        <S.Text>
          <p>
            <span>Casting:</span>
            <br />
            Thai de Melo
          </p>
          <p>
            <span>Foto:</span>
            <br />
            Juliana Rocha
          </p>
          <p>
            <span>Coord. de Produção de moda:</span>
            <br />
            Diego Tofolo
          </p>
          <p>
            <span>Produção de moda:</span>
            <br /> Thiago Torres
          </p>

          <p>
            <span>Assistente de moda:</span>
            <br />
            Lucas Lima
          </p>
          <p>
            <span>Produção de arte e cenografia:</span>
            <br />
            Anderson Rodriguez
          </p>
          <p>
            <span>Assistente de foto:</span>
            <br />
            Naelson de Castro
          </p>
          <p>
            <span>Assistente de foto:</span>
            <br />
            Aline Lins
          </p>
          <p>
            <span>Assistente de beleza:</span>
            <br />
            Gisele Santana
          </p>
          <p>
            <span>Manicure:</span>
            <br />
            Thayna Dandara
          </p>
          <p>
            <span>Produção executiva:</span>
            <br />
            Isabela de Paula
          </p>
          <p>
            <span>Assist. Produção executiva:</span>
            <br />
            Deise Cruz e Carlos Henrique
          </p>
          <p>
            <span>Contrarregra:</span>
            <br />
            Ronaldo Junge
          </p>
          <p>
            <span>Tratamento de imagem:</span>
            <br />
            Thiago Auge
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
